import { z } from "zod";
const text = (min, max) => z.string().trim().min(min).max(max);
const iso = z.iso.datetime({ offset: true });
const areaIds = z.array(z.number().int().min(1).max(77)).max(77);
export const adminEventBody = z
    .object({
    title: text(3, 120),
    description: z.string().trim().max(4000).default(""),
    startsAt: iso,
    endsAt: iso,
    venueName: text(2, 160),
    address: text(3, 240),
    lat: z.number().min(41.6).max(42.1).nullable().optional(),
    lng: z.number().min(-87.95).max(-87.5).nullable().optional(),
    capacity: z.number().int().min(1).max(10_000).nullable().default(null),
    hostName: z.string().trim().max(120).nullable().default(null),
    imageAttachmentId: z.uuid().nullable().default(null),
    allAreas: z.boolean().default(false),
    areaIds: areaIds.default([]),
    includeAdjacent: z.boolean().default(true),
})
    .refine((e) => new Date(e.endsAt) > new Date(e.startsAt), { message: "End must be after start", path: ["endsAt"] })
    .refine((e) => e.allAreas || e.areaIds.length > 0, { message: "Choose areas or 'All of Chicago'", path: ["areaIds"] });
export const adminCohortBody = z.object({
    name: text(3, 80),
    neighborhoodId: z.number().int().positive(),
    season: text(2, 40),
    startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().default(null),
});
export const adminCodeBody = z.object({
    code: z.string().trim().toUpperCase().regex(/^[A-Z0-9-]{4,32}$/, "Letters, numbers and dashes only").optional(),
    maxUses: z.number().int().min(1).max(10_000).nullable().default(null),
    expiresAt: iso.nullable().default(null),
});
export const adminAdBody = z
    .object({
    businessName: text(2, 80),
    headline: text(2, 80),
    body: text(2, 200),
    ctaLabel: text(2, 24).default("View offer"),
    landingTitle: text(2, 120),
    landingBody: text(2, 2000),
    promoCode: z.string().trim().max(40).nullable().default(null),
    redeemUrl: z.url().nullable().default(null),
    imageAttachmentId: z.uuid().nullable().default(null),
    startsAt: iso,
    endsAt: iso,
    impressionCap: z.number().int().positive().nullable().default(null),
    uniqueImpressionCap: z.number().int().positive().nullable().default(null),
    perUserCap: z.number().int().positive().nullable().default(null),
    weight: z.number().int().min(1).max(10).default(1),
    allAreas: z.boolean().default(false),
    areaIds: areaIds.default([]),
})
    .refine((a) => new Date(a.endsAt) > new Date(a.startsAt), { message: "End must be after start", path: ["endsAt"] })
    .refine((a) => a.allAreas || a.areaIds.length > 0, { message: "Choose areas or 'All of Chicago'", path: ["areaIds"] });
export const adminPlaceBody = z.object({
    title: text(2, 120),
    description: z.string().trim().max(2000).default(""),
    address: text(3, 240),
    lat: z.number().min(41.6).max(42.1).nullable().optional(),
    lng: z.number().min(-87.95).max(-87.5).nullable().optional(),
    tagIds: z.array(z.number().int().positive()).min(1, "Choose at least one category"),
    minAgeMonths: z.number().int().min(0).max(216).default(0),
    maxAgeMonths: z.number().int().min(0).max(216).default(216),
    website: z.url().nullable().default(null),
    phone: z.string().trim().max(40).nullable().default(null),
    highlights: z.array(text(1, 40)).max(8).default([]),
    imageAttachmentId: z.uuid().nullable().default(null),
    sponsoredUntil: iso.nullable().default(null),
    status: z.enum(["draft", "published", "archived"]).default("published"),
});
export const adminTagBody = z.object({ name: text(2, 40), icon: text(1, 20).default("star"), color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).default("#D1E2DF") });
export const adminLedgerBody = z.object({ hours: z.number().min(-60).max(60).refine((h) => h !== 0 && Math.round(h * 4) === h * 4, "Use quarter hours"), reason: text(3, 200) });
export const adminReportStatusBody = z.object({ status: z.enum(["reviewing", "actioned", "dismissed"]), note: z.string().trim().max(1000).default("") });
//# sourceMappingURL=admin.js.map